<template>
  <div class="auth-form-container">
    <internal-loading v-if="internalLoading"></internal-loading>
    <div class="auth-form" id="form-builder"></div>
    <el-button @click="onSubmit" class="auth-button">Enviar</el-button>
    <avisoSenha v-if="emailSent" :mensagem="emailSentMessage"></avisoSenha>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { renderForm } from '@mobilesaude/form-builder-sdk'
import avisoSenha from '@/components/shared/aviso-recuperar-senha/avisoSenha.vue'
import internalLoading from '../../shared/loading/InternalLoading'

export default {
  name: 'FormEsqueciMinhaSenha',
  components: {
    avisoSenha,
    internalLoading
  },
  data () {
    return {
      form: null,
      internalLoading: true,
      title: 'Esqueci minha senha',
      subTitle: 'Informe seu login e enviaremos instruções de como recuperar sua senha.',
      buttonBack: true,
      routerName: 'FormLogin',
      emailSent: false,
      emailSentMessage: ''
    }
  },
  mounted () {
    let params = {
      identifier: 'form-builder',
      clientKey: process.env.VUE_APP_CLIENTE_KEY,
      idForm: this.idsforms.formEsqueciSenha,
      colors: {
        primary: '#0075EA',
        errors: '#ff4949'
      },
      json: {
        contexto: this.contexto.slug
      }
    }
    this.form = renderForm(params)
    this.form.on('LOADING', res => {
      this.internalLoading = res
    })
  },
  methods: {
    ...mapActions('login', [
      'esqueciMinhaSenha',
      'getIds'
    ]),

    onSubmit () {
      this.form.validateAll().then(
        form => this.esqueciMinhaSenha(form.data))
    }
  },

  created () {
    this.$root.$emit('set-data-auth', {
      title: this.title,
      subTitle: this.subTitle,
      buttonBack: this.buttonBack,
      routerName: this.routerName
    })

    this.$root.$on('email-sent', (data) => {
      this.emailSent = data.status
      this.emailSentMessage = data.message
    })
  },
  computed: {
    ...mapState('login', [
      'loading',
      'contexto',
      'idsforms'
    ])
  }
}
</script>
<style lang="sass" scoped>
  @import url('https://fonts.googleapis.com/css?family=Nunito&display=swap')
  @import '../../../views/auth/auth.scss'
</style>
